import { getAuthorization } from 'controllers/controller';
import { setFlag } from 'controllers/flags';
import { getDocumentSignedUrlService } from 'services/expenseParser/getDocumentSignedUrl';
import { parseInvoiceService } from 'services/expenseParser/parseInvoice';
import { parseReceiptService } from 'services/expenseParser/parseReceipt';

export const expenseParser = async (files, type = 'invoice') => {
  const authorization = getAuthorization();

  if (files.length > 1) {
    setFlag('ResumeParserMultipleFilesError', true);
    return null;
  }

  const parseService =
    type === 'invoice' ? parseInvoiceService : parseReceiptService;

  const { data, status } = await parseService(authorization, files);

  if (status !== 200) {
    setFlag('ResumeParserFileTypeError', true);
    return null;
  }

  const parsedData = data && data.content ? data.content : null;

  const resumeLink = data
    ? await getDocumentSignedUrlService(authorization, data.filename)
    : null;

  return {
    json: parsedData,
    resumeLink: resumeLink.data ? resumeLink.data.response : '',
    filename: data ? data.filename : '',
  };
};
